import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcDeleteFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.25c5.385 0 9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25m4.064 5.688a.75.75 0 0 0-1.06 0l-3.009 3.008-3.009-3.008a.75.75 0 0 0-1.06 1.06l3.009 3.009-3.002 3.002a.75.75 0 1 0 1.06 1.06l3.002-3.002 3.002 3.002a.75.75 0 0 0 1.06-1.06l-3.001-3.002 3.008-3.009a.75.75 0 0 0 0-1.06",
    clipRule: "evenodd"
  }));
}
var IcDeleteFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcDeleteFill));

export { IcDeleteFill as I };
